<template>
    <div class="fdca-progress">
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg12 xl12>
                    Progress:
                    <div class="overall-progress-bar">
                        <div class="progress" :style="{ width: percent_progress + '%' }"></div>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import '@/assets/styles/progress-bar.scss'
import IconCheck from '@/components/icons/check.vue'
import IconBase from '@/components/IconBase.vue'
import IconPencil from '@/components/icons/pencil.vue'
import Globals from '@/assets/scripts/global-functions.js'

export default {
    name: "Progress",
    components: {
        IconCheck,
        IconBase,
        IconPencil,
        Globals
    },
    data: () => ({
        showContinue: false,
        route_path: '',
        isEdit: false,
        checkBeforeProceed: false,
        add_next_btn_active_color: false
    }),
    computed: {
        percent_progress: function() {
            let _current_progress = 0;
            if(this.$parent.Role == "service") {
                let _total_steps = 16;
                let _per_step = 100 / _total_steps;
                _current_progress = _per_step * this.$parent.ServiceProcessCurrentStep;
            } else if(this.$parent.Role == "educator") {
                let _total_steps = 19;
                let _per_step = 100 / _total_steps; 
                _current_progress = _per_step * this.$parent.EducatorProcessCurrentStep;
            }
            return _current_progress;
        }
    },
    mounted() {
        //this.CheckPath();
    },
    methods: {
        Edit(){
            this.$parent.EditStatus = true;
        },
        GetStepProgress(_process, _currentstep, _number_of_steps) {
            if(this.$parent.CurrentProcess == "ServiceInsuranceProcess") {
                let _total_steps = _number_of_steps;
                let _per_step = 100 / _number_of_steps;
                _current_progress = _per_step * this.$parent.ServiceInsuranceProcess.current_step;
            } else if(this.$parent.CurrentProcess == "EducatorInsuranceProcess") {
                let _total_steps = _number_of_steps;
                let _per_step = 100 / _number_of_steps;
                _current_progress = _per_step * this.$parent.EducatorInsuranceProcess.current_step;
            }
        }
    }
}
</script>

